import React from 'react'

import {ContentWrapper} from '@daedalus/atlas/src/components/designSystem/helpers/ContentWrapper'
import {BackendError} from '@daedalus/atlas/src/components/shared/booking/BackendError'
import {brands} from '@daedalus/core/src/brand/config'

export const GlobalCrashScreen = () => {
  return (
    <div style={{padding: '20px'}}>
      <h3>Failed to load Vio.com widget</h3>
    </div>
  )
}

export const WidgetCrashScreen = ({
  hideSupportLink
}: {
  hideSupportLink?: boolean
}) => {
  const onReloadClick = () => {
    window.location.reload()
  }

  const onSupportButtonClick = () => {
    window.open(brands.vio.contactUrl, '_blank')
  }

  return (
    <ContentWrapper paddingTopSize="s800">
      <BackendError
        onReloadClick={onReloadClick}
        onSupportLinkClick={hideSupportLink ? undefined : onSupportButtonClick}
      />
    </ContentWrapper>
  )
}
